<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 17 22"
    fill="none"
    class="outline-none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.27637 4.9997V6.7897C8.27637 7.2397 8.81637 7.4597 9.12637 7.1397L11.9164 4.3497C12.1164 4.1497 12.1164 3.8397 11.9164 3.6397L9.12637 0.849697C8.81637 0.539697 8.27637 0.759697 8.27637 1.2097V2.9997C3.85637 2.9997 0.276367 6.5797 0.276367 10.9997C0.276367 12.0397 0.476367 13.0397 0.846367 13.9497C1.11637 14.6197 1.97637 14.7997 2.48637 14.2897C2.75637 14.0197 2.86637 13.6097 2.71637 13.2497C2.42637 12.5597 2.27637 11.7897 2.27637 10.9997C2.27637 7.6897 4.96637 4.9997 8.27637 4.9997ZM14.0664 7.7097C13.7964 7.9797 13.6864 8.3997 13.8364 8.7497C14.1164 9.4497 14.2764 10.2097 14.2764 10.9997C14.2764 14.3097 11.5864 16.9997 8.27637 16.9997V15.2097C8.27637 14.7597 7.73637 14.5397 7.42637 14.8597L4.63637 17.6497C4.43637 17.8497 4.43637 18.1597 4.63637 18.3597L7.42637 21.1497C7.73637 21.4597 8.27637 21.2397 8.27637 20.7997V18.9997C12.6964 18.9997 16.2764 15.4197 16.2764 10.9997C16.2764 9.9597 16.0764 8.9597 15.7064 8.0497C15.4364 7.3797 14.5764 7.1997 14.0664 7.7097Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'ReloadIcon',
  props: {
    width: {
      type: Number,
      default: 17
    },
    height: {
      type: Number,
      default: 22
    },
    color: {
      type: String,
      default: '#73777A'
    }
  }
}
</script>
